exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message-counter[data-v-4860fae0] {\n\ttext-align: center;\n\tcolor: var(--wf-tertiary);\n\tfont-weight: 600;\n\tposition: absolute;\n\tcursor: pointer;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.message-counter[data-v-4860fae0]:hover {\n\tbackground: var(--secondary-tertiary-mix95);\n}\n.message-counter img[data-v-4860fae0] {\n\tmax-width: 50px;\n}\n.message-count[data-v-4860fae0] {\n\tposition: absolute;\n\ttransform: translate(-50%, -25%);\n\tcolor: var(--wf-secondary);\n\tfont-size: 1rem;\n}\n", ""]);

// exports
